/* eslint-disable no-unused-vars */
import $http from '../../shared/http';

export const denominations = {
  namespaced: true,
  state: () => {
    return {
      denominationsForSelect: null,
      denominationsList: null,
      denominationDetails: null,
      denominationLevelDetails: null,
      denominationLevelsForSelect: null,
      denominationLevelChurchesForSelect: null,
      denominationParentLevelBranchesForSelect: [],
      denominationLevelsForIndividualDenomination: null,
      denominationLevelParentBranchesForSelect: null,
      denominationRootLevelBranch: null,
      denominationChurchesForSelect: null,
      denominationLevelBranchDetails: null,
    };
  },
  getters: {
    GET_DENOMINATIONS_LIST: (state) => state.denominationsList,
    GET_DENOMINATIONS_FOR_SELECT: (state) => state.denominationsForSelect,
    GET_DENOMINATION_DETAILS: (state) => state.denominationDetails,
    GET_DENOMINATION_LEVEL_DETAILS: (state) => state.denominationLevelDetails,
    GET_DENOMINATION_LEVELS_FOR_SELECT: (state) => state.denominationLevelsForSelect,
    GET_DENOMINATION_LEVEL_CHURCHES_FOR_SELECT: (state) => state.denominationLevelChurchesForSelect,
    GET_DENOMINATION_PARENT_LEVEL_BRANCHES_FOR_SELECT: (state) =>
      state.denominationParentLevelBranchesForSelect,
    GET_DENOMINATION_LEVELS_FOR_INDIVIDUAL_DENOMINATION: (state) =>
      state.denominationLevelsForIndividualDenomination,
    GET_DENOMINATION_LEVEL_PARENT_BRANCHES_FOR_SELECT: (state) =>
      state.denominationLevelParentBranchesForSelect,
    GET_DENOMINATION_ROOT_LEVEL_BRANCH: (state) => state.denominationRootLevelBranch,
    GET_DENOMINATION_CHURCHES_FOR_SELECT: (state) => state.denominationChurchesForSelect,
    GET_DENOMINATION_LEVEL_BRANCH_DETAILS: (state) => state.denominationLevelBranchDetails,
  },
  mutations: {
    setDenominationsForSelect: (state, payload) => (state.denominationsForSelect = payload),
    setDenominationsList: (state, payload) => (state.denominationsList = payload),
    setDenominationDetails: (state, payload) => (state.denominationDetails = payload),
    setDenominationLevelDetails: (state, payload) => (state.denominationLevelDetails = payload),
    setDenominationLevelsForSelect: (state, payload) =>
      (state.denominationLevelsForSelect = payload),
    setDenominationLevelChurchesForSelect: (state, payload) =>
      (state.denominationLevelChurchesForSelect = payload),
    setDenominationParentLevelBranchesForSelect: (state, payload) =>
      (state.denominationParentLevelBranchesForSelect = payload),
    setDenominationLevelsForIndividualDenomination: (state, payload) =>
      (state.denominationLevelsForIndividualDenomination = payload),
    setDenominationLevelParentBranchesForSelect: (state, payload) =>
      (state.denominationLevelParentBranchesForSelect = payload),
    setDenominationRootLevelBranch: (state, payload) =>
      (state.denominationRootLevelBranch = payload),
    setDenominationChurchesForSelect: (state, payload) =>
      (state.denominationChurchesForSelect = payload),
    setDenominationLevelBranchDetails: (state, payload) =>
      (state.denominationLevelBranchDetails = payload),
  },
  actions: {
    async LOAD_DENOMINATIONS_FOR_SELECT({ commit }) {
      return $http('v2')
        .get('/denominations/select')
        .then((response) => {
          commit('setDenominationsForSelect', response.data.data);
          return response;
        });
    },

    async LOAD_DENOMINATIONS_LIST({ commit }) {
      return new Promise(async (resolve, reject) => {
        await $http()
          .get('/denominations/denominations-list')
          .then((response) => {
            commit('setDenominationsList', response.data.data);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    async LOAD_DENOMINATION_DETAILS({ commit }, id) {
      return new Promise(async (resolve, reject) => {
        await $http()
          .get(`/denominations/${id}`)
          .then((response) => {
            commit('setDenominationDetails', response.data.data);
            resolve(response);
          })
          .catch((error) => {
            commit('setDenominationDetails', null);
            reject(error);
          });
      });
    },

    async LOAD_DENOMINATION_LEVEL_DETAILS({ commit }, { denominationId, levelId }) {
      return new Promise(async (resolve, reject) => {
        await $http()
          .get(`/denominations/${denominationId}/levels/${levelId}`)
          .then((response) => {
            commit('setDenominationLevelDetails', response.data);
            resolve(response);
          })
          .catch((error) => {
            commit('setDenominationLevelDetails', null);
            reject(error);
          });
      });
    },

    async EDIT_DENOMINATION_ACTION(_ctx, form) {
      return $http('v2').put(`/denominations/${form.id}`, form, { notifiable: true });
    },

    async CREATE_DENOMINATION_ACTION(_ctx, form) {
      return new Promise(async (resolve, reject) => {
        await $http('v2')
          .post(`/denominations`, form, { headers: { 'X-Is-Notifiable': 'On' } })
          .then((response) => {
            return resolve(response);
          })
          .catch((error) => {
            return reject(error);
          });
      });
    },

    async CREATE_DENOMINATION_CHURCH_ACTION(_ctx, { denominationId, form }) {
      return new Promise(async (resolve, reject) => {
        await $http()
          .post(`denominations/${denominationId}/churches`, form, {
            headers: { 'X-Is-Notifiable': 'On' },
          })
          .then((response) => {
            return resolve(response.data);
          })
          .catch((error) => {
            return reject(error);
          });
      });
    },

    async MASS_DISSOCIATE_CHURCHES_FROM_DENOMINATIONS_ACTION(_ctx, { denominationId, churches }) {
      return new Promise(async (resolve, reject) => {
        await $http()
          .post(
            `denominations/${denominationId}/dissociate-churches`,
            { organisation_ids: churches },
            { headers: { 'X-Is-Notifiable': 'On' } }
          )
          .then((response) => {
            return resolve(response.data);
          })
          .catch((error) => {
            return reject(error);
          });
      });
    },

    async MASS_DISSOCIATE_CHURCHES_FROM_DENOMINATION_LEVEL_ACTION(
      _ctx,
      { denominationId, denominationLevelId, churches }
    ) {
      return new Promise(async (resolve, reject) => {
        await $http()
          .post(
            `denominations/${denominationId}/levels/${denominationLevelId}/dissociate-churches`,
            {
              organisation_ids: churches,
            },
            { headers: { 'X-Is-Notifiable': 'On' } }
          )
          .then((response) => {
            return resolve(response.data);
          })
          .catch((error) => {
            return reject(error);
          });
      });
    },

    async MASS_CHURCHES_ASSIGNMENT_TO_DENOMINATION_ACTION(_ctx, { ids, denomination_id }) {
      return new Promise(async (resolve, reject) => {
        await $http()
          .patch(
            `denominations/${denomination_id}/churches`,
            { organisation_ids: ids },
            { headers: { 'X-Is-Notifiable': 'On' } }
          )
          .then((response) => {
            return resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    async MASS_CHURCHES_ASSIGNMENT_TO_DENOMINATION_LEVEL_ACTION(
      _ctx,
      { ids, form, denominationId }
    ) {
      return new Promise(async (resolve, reject) => {
        await $http('v2')
          .post(
            `denominations/${denominationId}/levels/${form.denomination_level_id}/churches`,
            {
              organisation_ids: ids,
              parent_branch_id: form.parent_branch_id,
            },
            { headers: { 'X-Is-Notifiable': 'On' } }
          )
          .then((response) => {
            return resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    async CREATE_DENOMINATION_LEVEL_ACTION(_ctx, { denominationId, form }) {
      return new Promise(async (resolve, reject) => {
        await $http()
          .post(`denominations/${denominationId}/levels`, form, {
            headers: { 'X-Is-Notifiable': 'On' },
          })
          .then((response) => {
            return resolve(response.data);
          })
          .catch((error) => {
            return reject(error);
          });
      });
    },

    async EDIT_DENOMINATION_LEVEL_ACTION(_ctx, { denominationId, denominationLevelId, form }) {
      return new Promise(async (resolve, reject) => {
        await $http()
          .put(`denominations/${denominationId}/levels/${denominationLevelId}`, form, {
            headers: { 'X-Is-Notifiable': 'On' },
          })
          .then((response) => {
            return resolve(response.data);
          })
          .catch((error) => {
            return reject(error);
          });
      });
    },

    async DELETE_DENOMINATION_LEVEL_ACTION(_ctx, { denominationId, denominationLevelId }) {
      return new Promise(async (resolve, reject) => {
        await $http()
          .delete(`denominations/${denominationId}/levels/${denominationLevelId}`, {
            headers: { 'X-Is-Notifiable': 'On' },
          })
          .then((response) => {
            return resolve(response.data);
          })
          .catch((error) => {
            return reject(error);
          });
      });
    },

    async LOAD_DENOMINATION_LEVELS_FOR_SELECT({ commit }, denominationId) {
      return $http('v2')
        .get(`/denominations/${denominationId}/levels/select`)
        .then((response) => {
          commit('setDenominationLevelsForSelect', response.data.data);
          return response;
        });
    },

    async LOAD_DENOMINATION_LEVEL_CHURCHES_FOR_SELECT(
      { commit },
      { denominationId, denominationLevelId }
    ) {
      return $http('v2')
        .get(`/denominations/${denominationId}/levels/${denominationLevelId}/churches/select`)
        .then((response) => {
          commit('setDenominationLevelChurchesForSelect', response.data);
          return response;
        });
    },

    async LOAD_DENOMINATION_PARENT_LEVEL_BRANCHES_FOR_SELECT(
      { commit },
      { denominationId, denominationLevelId }
    ) {
      return $http('v2')
        .get(
          `/denominations/${denominationId}/levels/${denominationLevelId}/parent_level_branches/select`
        )
        .then((response) => {
          commit('setDenominationParentLevelBranchesForSelect', response.data.data);
          return response;
        });
    },

    async LOAD_LEVELS_FOR_INDIVIDUAL_DENOMINATION_ACTION({ commit }, denominationId) {
      return new Promise(async (resolve, reject) => {
        await $http()
          .get(`/denominations/${denominationId}/levels`)
          .then((response) => {
            commit('setDenominationLevelsForIndividualDenomination', response.data);
            // return data directly to the component
            resolve(response.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    async LOAD_DENOMINATION_BRANCH_AT_ROOT_LEVEL({ commit }, denominationId) {
      return new Promise(async (resolve, reject) => {
        await $http()
          .get(`/denominations/${denominationId}/root-branch`)
          .then((response) => {
            commit('setDenominationRootLevelBranch', response.data);
            // return data directly to the component
            resolve(response.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    async LOAD_DENOMINATION_DESCENDANT_BRANCHES(_ctx, { denominationId, ancestorBranchId }) {
      return new Promise(async (resolve, reject) => {
        await $http()
          .get(`/denominations/${denominationId}/branches/${ancestorBranchId}/descendants`)
          .then((response) => {
            // return data directly to the component
            resolve(response.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    async LOAD_DENOMINATION_LEVEL_BRANCH_DETAILS({ commit }, { denominationId, branchId }) {
      return new Promise(async (resolve, reject) => {
        await $http()
          .get(`denominations/${denominationId}/branches/${branchId}`)
          .then((response) => {
            commit('setDenominationLevelBranchDetails', response.data);
            return resolve(response.data);
          })
          .catch((error) => {
            return reject(error);
          });
      });
    },

    async CREATE_DENOMINATION_LEVEL_BRANCH_ACTION(
      _ctx,
      { denominationId, denominationLevelId, form }
    ) {
      return new Promise(async (resolve, reject) => {
        await $http('v2')
          .post(`denominations/${denominationId}/levels/${denominationLevelId}/branches`, form, {
            headers: { 'X-Is-Notifiable': 'On' },
          })
          .then((response) => {
            return resolve(response.data);
          })
          .catch((error) => {
            return reject(error);
          });
      });
    },

    async EDIT_DENOMINATION_LEVEL_BRANCH_ACTION(_ctx, { denominationId, branchId, form }) {
      return new Promise(async (resolve, reject) => {
        await $http('v2')
          .put(`denominations/${denominationId}/branches/${branchId}`, form, {
            headers: { 'X-Is-Notifiable': 'On' },
          })
          .then((response) => {
            return resolve(response.data);
          })
          .catch((error) => {
            return reject(error);
          });
      });
    },

    async LOAD_DENOMINATION_CHURCHES_FOR_SELECT(
      { commit },
      { denominationId, searchQuery, omitAssignedChurch }
    ) {
      return $http('v2')
        .get(`/denominations/${denominationId}/churches/select`, {
          params: {
            omit_assigned_churches: omitAssignedChurch ? true : undefined,
            query: searchQuery ?? undefined,
          },
        })
        .then((response) => {
          commit('setDenominationChurchesForSelect', response.data);
          return response;
        });
    },
  },
};
